// extracted by mini-css-extract-plugin
module.exports = {"main":"Post-module--main--28N-L","content":"Post-module--content--32UeQ","postTitle":"Post-module--post-title--hHaz9","divider":"Post-module--divider--3Tvcb"};